import React, { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import successImg from '../../../assets/img/icon/success_gif.gif'
import { FaCheckCircle, FaInfoCircle } from 'react-icons/fa'
import CardsProgressSteps from '../../../components/ProgressStep/CardsProgressSteps'
import { fetchWallets, getFormattedAmount, updateTransactionProcess, verifyTransaction } from '../../../actions/payments'
import { getAuthenticatedUser } from '../../../actions/auth'
import { useDispatch } from 'react-redux'

function AddMoneySuccess() {
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();
    // const amount = 200;
    // const currencyCode = "NGN";
    const { amount, currencyCode, status } = location.state || {};
    const isPayloadEmpty = !amount || !currencyCode;

    // useEffect(() => {
    //     if (isPayloadEmpty) {
    //         navigate("/user/add_money", { replace: true });
    //         return;
    //     }
    // }, [isPayloadEmpty, navigate]);
    

    // const triggerUserAuth = async () => {
    //     try {
    //         await getAuthenticatedUser(dispatch);
    //         setTimeout(() => window.location.reload(), 3000);
    //     } catch (error) {
    //         console.error("Error fetching authenticated user:", error);
    //     }
    // }
    // useEffect(() => {
    //   triggerUserAuth();
    // }, []);
    

    const goToTxnPage = () => {
        navigate('/user/transactions');
    }

// useEffect(() => {
//     const key = 'hasReloaded_AddMoneyFailed';
//     const lastPath = sessionStorage.getItem('lastPath');
//     const currentPath = location.pathname + location.search;

//     const hasReloaded = sessionStorage.getItem(key);

//     if (hasReloaded !== 'true' || lastPath !== currentPath) {
//         sessionStorage.setItem(key, 'true');

//         sessionStorage.setItem('lastPath', currentPath);

//         const timer = setTimeout(() => {
//             window.location.reload();
//         }, 3000); 

//         return () => clearTimeout(timer);
//     }
// }, [location]);

    return (
        <div>
            <div className="create__card__page send__money__page pt-2">

                <div className='auth__container__box mt-4 shadow-none rounded'>
                    {status == 'successful' 
                        ? <FaCheckCircle size={80} color="green" className="mb-4 d-flex justify-content-center mx-auto" />
                        : <FaInfoCircle size={80} color="#62b9b8" className="mb-4 d-flex justify-content-center mx-auto" />
                    }
                    <h3 className=''>
                        {status == 'successful' ? 'Successful' : 'Pending'}
                    </h3>
        
                    <p className='auth__text '>
                        {status == 'successful' ? <>
                            You have successfully added money to your wallet
                        </>:<>
                            Your payment is currently pending. 
                        </>}
                    </p>

                    <h1 className='text-center my-2'>{currencyCode} {getFormattedAmount(amount)}</h1>

                    <button onClick={goToTxnPage} className='btn btn-primary w-100 mt-4'>
                        See transactions
                    </button>

                    <button onClick={() => navigate('/user/dashboard')} className='btn btn-outline-light text-dark w-100 mt-3'>
                        Go to Dashboard
                    </button>
                </div>


            </div>
        </div>
    )
}

export default AddMoneySuccess;